/* eslint-disable no-bitwise */
/* eslint-disable import/prefer-default-export */
import { ApiExceptionResponse } from 'api/types';
import 'react-datepicker/dist/react-datepicker.css';
import toast from 'react-hot-toast';

export const showException = async (error: any) => {
  if (typeof error === 'string') {
    toast.error(error);
    return;
  }

  let exception = error?.response?.data as ApiExceptionResponse;

  // Handle blob responses (from file download errors)
  if (exception instanceof Blob) {
    try {
      const text = await exception.text();
      exception = JSON.parse(text);
    } catch {
      toast.error('Ett fel uppstod');
      return;
    }
  }

  // [Authorize]/Forbid() svarar 401/403 utan body, så statusen finns bara på
  // själva HTTP-svaret — inte i exception.
  const status = error?.response?.status ?? exception?.status;
  if (status === 401) {
    toast.error('Du är inte inloggad');
    return;
  }
  if (status === 403) {
    toast.error('Du har inte behörighet att göra detta');
    return;
  }
  toast.error(exception?.title || 'Ett fel uppstod');
};
